import loglevel from "loglevel";

export default loglevel.getLogger("torus-direct-web-sdk");
